import { makeStyles } from '@material-ui/core/styles';
import { useForm } from 'react-hook-form';

import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import TextField from 'components/CncUI/TextField';
import Button from 'components/CncUI/Button';

import isEmail from 'utilities/validateEmail';

const useStyles = makeStyles(() => ({
  field: {
    width: 320,
  },
  button: {
    width: 100,
    marginBottom: 22,
  },
  clearButton: {
    width: 'auto',
    marginBottom: 22,
  },
}));

const Controls = props => {
  const classes = useStyles();
  const { onSearch, loading, clear } = props;
  const { register, handleSubmit, errors, reset } = useForm();

  const submitForm = data => {
    onSearch(data.search);
  };

  const inputValid = {
    validate: value => isEmail(value) || 'Please enter an email',
  };

  const onKeyDown = async e => {
    const { charCode, keyCode } = e || {};
    // Enter key 13
    if (charCode === 13 || keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      if (!loading) handleSubmit(submitForm)();
    }
  };

  const onClear = () => {
    reset();
    clear();
  };

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item>
          <TextField
            light
            id="SearchField"
            name="search"
            label="Search"
            onKeyDown={onKeyDown}
            startIcon={<SearchIcon />}
            inputRef={register({
              required: 'Missing input',
              ...inputValid,
            })}
            error={Boolean(errors.search)}
            helperText={(errors.search && errors.search.message) || ' '}
            className={classes.field}
          />
        </Grid>
        <Grid item>
          <Button
            id="SearchButton"
            loading={loading}
            disabled={Boolean(errors.search)}
            className={classes.button}
            type="submit"
          >
            Search
          </Button>
        </Grid>
        <Grid item>
          <Button
            id="ClearButton"
            loading={loading}
            disabled={Boolean(errors.search)}
            className={classes.clearButton}
            onClick={onClear}
            secondary
          >
            Clear Results
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default Controls;
